import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { onlyNumber } from "../../constant/utils";
import { validateSubmitForm } from "../../constant/validation";
import { dashboardAction, submitAction } from "../../redux/action";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  CityId: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha: "",
};
const SubmitForm = (props: any) => {
  const { t } = useTranslation();
  const { heading, des, PageSrc, validationSchema } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const loading = useSelector((state: any) => state.common.loader);

  const handleSubmit = (val: any) => {
    let data: any = { ...val };
    data.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    data.UtmSource = urlParams.get("utm_source");
    data.UtmMedium = urlParams.get("utm_medium");
    data.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitQueryAction(data, history));
  };
  return (
    <section className="department_form section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="headingmains text-center pb-3">
              <h1 className="right aos-init pb-2"> {heading} </h1>
              <p>{des}</p>
            </div>
          </div>
        </div>
        <Formik
          initialValues={initialValue}
          enableReinitialize={true}
          validationSchema={
            validationSchema ? validationSchema : validateSubmitForm
          }
          onSubmit={(val: any) => {
            handleSubmit(val);
          }}
          render={({
            values,
            handleChange,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }: any) => (
            <form onSubmit={handleSubmit}>
              <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-9 col-xl-9">
                  <div className="row align-items-center mt-3">
                    <div className="col-sm">
                      <input
                        type="text"
                        name="Name"
                        className="form-control"
                        placeholder={t("name")}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.Name}
                      />
                      {touched?.Name && errors?.Name && (
                        <span className="error_message">{t(errors?.Name)}</span>
                      )}
                    </div>
                    <div className="col-sm mt-3 mt-sm-0">
                      <input
                        type="text"
                        name="Mobile"
                        className="form-control"
                        placeholder={t("mobile_number")}
                        onKeyPress={onlyNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.Mobile}
                      />
                      {touched?.Mobile && errors?.Mobile && (
                        <span className="error_message">
                          {t(errors?.Mobile)}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row align-items-center mt-3">
                    <div className="col-sm">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("email")}
                        name="Email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.Email}
                      />
                      {touched?.Email && errors?.Email && (
                        <span className="error_message">
                          {t(errors?.Email)}
                        </span>
                      )}
                    </div>
                    <div className="col-sm mt-3 mt-sm-0">
                      <select
                        className="form-control"
                        name="CityId"
                        id="CityId"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.CityId}
                      >
                        <option value="">{t("city-with*")}</option>
                        {cityData &&
                          cityData.length > 0 &&
                          cityData?.map((item: any, i: any) => (
                            <option
                              className="text-uppercase"
                              value={item?.Id}
                              key={i}
                            >
                              {t(item?.Name)}
                            </option>
                          ))}
                      </select>
                      {touched?.CityId && errors?.CityId && (
                        <span className="error_message">
                          {t(errors?.CityId)}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col mt-3">
                      <textarea
                        className="form-control"
                        placeholder={t("message")}
                        name="Message"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.Message}
                      ></textarea>
                      {touched?.Message && errors?.Message && (
                        <span className="error_message">
                          {t(errors?.Message)}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* check box */}
                  <div className="d-flex mt-3 for-check-style">
                    <input
                      type="checkbox"
                      name="Checkbox"
                      checked={values?.Checkbox}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="checkbox_id"
                    />
                    <label className="mx-2" htmlFor="checkbox_id">
                      By clicking you accept to the{" "}
                      <a
                        className="text-info"
                        href="https://oncquestlabs.com/terms-condition"
                      >
                        terms and conditions
                      </a>{" "}
                      and the{" "}
                      <a
                        className="text-info"
                        href="https://oncquestlabs.com/privacy-policy"
                      >
                        Privacy Policy.
                      </a>
                    </label>
                  </div>
                  <div>
                    {touched?.Checkbox && errors?.Checkbox && (
                      <span className="error_message">{errors?.Checkbox}</span>
                    )}
                  </div>
                  <div className="row align-items-center mt-2">
                    <div className="col-12">
                      <Recaptcha
                        touch={touched?.GRecaptcha}
                        error={errors?.GRecaptcha}
                        onChange={(token: any) =>
                          setFieldValue("GRecaptcha", token)
                        }
                        onExpired={() => setFieldValue("GRecaptcha", "")}
                      />
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col">
                      <button
                        type="submit"
                        className="button--hexagon active mt-3"
                        disabled={loading}
                      >
                        <span>
                          {loading ? (
                            <>
                              Submitting...
                              <i className="fa fa-spinner fa-spin ml-20"></i>
                            </>
                          ) : (
                            <>
                              {t("submit_btn")}{" "}
                              <p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16.817"
                                  height="10.695"
                                  viewBox="0 0 16.817 10.695"
                                >
                                  <path
                                    id="Icon_material-arrow-forward"
                                    data-name="Icon material-arrow-forward"
                                    d="M0,6l-.942.942,3.73,3.737H-11.47v1.337H2.787l-3.73,3.737L0,16.695l5.347-5.347Z"
                                    transform="translate(11.47 -6)"
                                    fill="#114a82"
                                  ></path>
                                </svg>
                              </p>
                            </>
                          )}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        />
      </div>
    </section>
  );
};
export default React.memo(SubmitForm);
